<template>
    <div>
        <h1 class="ma-12">{{$translate("Oops! The page you're looking for does not exist")}}</h1>
        <!-- <h2>Path: {{$route.path}}</h2> -->
    </div>
</template>

<script>
export default {
    name: 'PageNotFound',
    created() {
        let meta = this._metaNode = document.createElement('meta');
        meta.name = 'robots';
        meta.content = 'noindex';
        document.head.appendChild(meta);
    },
    destroyed() {
        this._metaNode.remove();
    }
}
</script>
